module.exports = __webpack_public_path__ + "img/04-door-back.be457ae4.png";